// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/arrow-right.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up {
  max-width: 1386px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 200px auto 70px auto;
}

.sign-up__header-container {
  display: flex;
  margin: 0 0 80px 0;
}

.sign-up__header-line {
  width: 367px;
  height: 1px;
  background-color: white;
  margin: 35px 28px 0px auto;
}

.sign-up__header {
  font-family: "Playfair Display";
  font-weight: 500;
  line-height: 50px;
  font-size: 60px;
  margin: 0;
}

.sign-up__box {
  margin: 0 auto;
  padding: 0;
  width: 912px;
  height: 470px;
  border: 1px solid white;
  display: flex;
  flex-direction: column;
}

.sign-up__box-title {
  font-size: 30px;
  font-weight: 500;
  font-family: 'Montserrat';
  line-height: 40px;
  width: 441px;
  text-align: center;
  margin: 79px auto 53px;
  padding: 0;
}

.sign-up__box-list {
  display: flex;
  flex-direction: column;
  list-style: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin: 0 384px 115px 336px;
  padding: 0;
}

.sign-up__box-item {
  margin: 0 0 64px 0;
  padding: 0;
}

.sign-up__link {
  font-size: 30px;
  font-weight: 500;
  font-family: 'Montserrat';
  line-height: 40px;
  text-transform: uppercase;
  color: rgba(95, 74, 62, 0.9);
  margin: 0 0 0 36px;
  transition: all .3s;
}

.sign-up__link:hover {
  color: white;
}

@media screen and (max-width: 1439px) {
  .sign-up {
    max-width: 984px;
    margin: 100px auto 100px auto;
  }

  .sign-up__header-container {
    margin: 0 auto 57px auto;
  }

  .sign-up__header-line {
    width: 90px;
    margin: 35px 36px 0px 0;
  }

  .sign-up__header {
    line-height: 50px;
    font-size: 45px;
  }

  .sign-up__box {
    width: 584px;
    height: 370px;
  }

  .sign-up__box-title {
    font-size: 26px;
    line-height: 36px;
    width: 382px;
    margin: 40px auto 70px;
    padding: 0;
  }

  .sign-up__box-list {
    margin: 0 155px 115px auto;
    padding: 0;
  }

  .sign-up__box-item {
    margin: 0 0 40px 0;
  }

  .sign-up__link {
    font-size: 26px;
    line-height: 36px;
  }
}

@media screen and (max-width: 1023px) {
  .sign-up {
    max-width: 708px;
    margin: 75px auto 75px auto;
  }

  .sign-up__header-line {
    width: 180px;
  }

  .sign-up__header {
    font-size: 35px;
    line-height: 40px;
  }

  .sign-up__box-title {
    font-size: 22px;
    line-height: 32px;
  }

  .sign-up__box-list {
    margin: 0 160px 115px auto;
    padding: 0;
  }

  .sign-up__link {
    font-size: 22px;
    line-height: 32px;
  }
}

@media screen and (max-width: 763px) {
  .sign-up {
    max-width: 320px;
    margin: 86px auto 71px auto;
  }

  .sign-up__header-container {
    display: flex;
    margin: 0 0 60px 0;
  }

  .sign-up__header-line {
    display: none;
  }

  .sign-up__header {
    line-height: 46px;
    font-size: 33px;
  }

  .sign-up__box {
    width: 100%;
    height: fit-content;
    border: 1px solid white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .sign-up__box-title {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    width: 229px;
    margin: 44px auto 50px;
  }

  .sign-up__box-list {
    list-style: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin: 0;
  }

  .sign-up__box-item {
    margin: 0 0 60px 86px;
  }

  .sign-up__box-item:last-of-type {
    margin-bottom: 20px;
  }

  .sign-up__link {
    font-size: 24px;
    line-height: 34px;
    margin: 0 0 0 26px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SignUp/SignUp.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mDAA+C;EAC/C,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,mDAA+C;IAC/C,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".sign-up {\r\n  max-width: 1386px;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 200px auto 70px auto;\r\n}\r\n\r\n.sign-up__header-container {\r\n  display: flex;\r\n  margin: 0 0 80px 0;\r\n}\r\n\r\n.sign-up__header-line {\r\n  width: 367px;\r\n  height: 1px;\r\n  background-color: white;\r\n  margin: 35px 28px 0px auto;\r\n}\r\n\r\n.sign-up__header {\r\n  font-family: \"Playfair Display\";\r\n  font-weight: 500;\r\n  line-height: 50px;\r\n  font-size: 60px;\r\n  margin: 0;\r\n}\r\n\r\n.sign-up__box {\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  width: 912px;\r\n  height: 470px;\r\n  border: 1px solid white;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sign-up__box-title {\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  font-family: 'Montserrat';\r\n  line-height: 40px;\r\n  width: 441px;\r\n  text-align: center;\r\n  margin: 79px auto 53px;\r\n  padding: 0;\r\n}\r\n\r\n.sign-up__box-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  list-style: url('../../images/arrow-right.svg');\r\n  margin: 0 384px 115px 336px;\r\n  padding: 0;\r\n}\r\n\r\n.sign-up__box-item {\r\n  margin: 0 0 64px 0;\r\n  padding: 0;\r\n}\r\n\r\n.sign-up__link {\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  font-family: 'Montserrat';\r\n  line-height: 40px;\r\n  text-transform: uppercase;\r\n  color: rgba(95, 74, 62, 0.9);\r\n  margin: 0 0 0 36px;\r\n  transition: all .3s;\r\n}\r\n\r\n.sign-up__link:hover {\r\n  color: white;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .sign-up {\r\n    max-width: 984px;\r\n    margin: 100px auto 100px auto;\r\n  }\r\n\r\n  .sign-up__header-container {\r\n    margin: 0 auto 57px auto;\r\n  }\r\n\r\n  .sign-up__header-line {\r\n    width: 90px;\r\n    margin: 35px 36px 0px 0;\r\n  }\r\n\r\n  .sign-up__header {\r\n    line-height: 50px;\r\n    font-size: 45px;\r\n  }\r\n\r\n  .sign-up__box {\r\n    width: 584px;\r\n    height: 370px;\r\n  }\r\n\r\n  .sign-up__box-title {\r\n    font-size: 26px;\r\n    line-height: 36px;\r\n    width: 382px;\r\n    margin: 40px auto 70px;\r\n    padding: 0;\r\n  }\r\n\r\n  .sign-up__box-list {\r\n    margin: 0 155px 115px auto;\r\n    padding: 0;\r\n  }\r\n\r\n  .sign-up__box-item {\r\n    margin: 0 0 40px 0;\r\n  }\r\n\r\n  .sign-up__link {\r\n    font-size: 26px;\r\n    line-height: 36px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .sign-up {\r\n    max-width: 708px;\r\n    margin: 75px auto 75px auto;\r\n  }\r\n\r\n  .sign-up__header-line {\r\n    width: 180px;\r\n  }\r\n\r\n  .sign-up__header {\r\n    font-size: 35px;\r\n    line-height: 40px;\r\n  }\r\n\r\n  .sign-up__box-title {\r\n    font-size: 22px;\r\n    line-height: 32px;\r\n  }\r\n\r\n  .sign-up__box-list {\r\n    margin: 0 160px 115px auto;\r\n    padding: 0;\r\n  }\r\n\r\n  .sign-up__link {\r\n    font-size: 22px;\r\n    line-height: 32px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .sign-up {\r\n    max-width: 320px;\r\n    margin: 86px auto 71px auto;\r\n  }\r\n\r\n  .sign-up__header-container {\r\n    display: flex;\r\n    margin: 0 0 60px 0;\r\n  }\r\n\r\n  .sign-up__header-line {\r\n    display: none;\r\n  }\r\n\r\n  .sign-up__header {\r\n    line-height: 46px;\r\n    font-size: 33px;\r\n  }\r\n\r\n  .sign-up__box {\r\n    width: 100%;\r\n    height: fit-content;\r\n    border: 1px solid white;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .sign-up__box-title {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 24px;\r\n    width: 229px;\r\n    margin: 44px auto 50px;\r\n  }\r\n\r\n  .sign-up__box-list {\r\n    list-style: url('../../images/arrow-right.svg');\r\n    margin: 0;\r\n  }\r\n\r\n  .sign-up__box-item {\r\n    margin: 0 0 60px 86px;\r\n  }\r\n\r\n  .sign-up__box-item:last-of-type {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .sign-up__link {\r\n    font-size: 24px;\r\n    line-height: 34px;\r\n    margin: 0 0 0 26px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
